export default __webpack_public_path__ + "static/media/logo_connected.48dd865d.svg";